var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"gauge"},[_c('div',{attrs:{"id":"chart"}},[_c('vue-apex-charts',{attrs:{"type":"radialBar","options":_vm.chartOptions,"series":_vm.valor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }